(function (angular) {
	'use strict';

	angular
		.module('serviceLevelModule')
		.controller('UpgradeOverview', [
			'ServiceLevelFactory',
			'STATIC_BASE_PATH',
			'urlFactory',
			UpgradeOverviewFunction
		]);

	function UpgradeOverviewFunction(
		ServiceLevelFactory,
		STATIC_BASE_PATH,
		urlFactory) {

		var upgradeOverview = this;

		upgradeOverview.nextStep = function() {
			if(upgradeOverview.completeUpgradeAndRedirectToSuccess) {
				ServiceLevelFactory.upgradeServiceLevelAndRiaPlan(upgradeOverview.nextServiceLevel.name, upgradeOverview.riaPlanId)
					.then(function() {
						urlFactory.redirect('/account/upgrade/' + upgradeOverview.nextServiceLevel.name.toLowerCase()  + '/success');
					});
			}
			else {
				urlFactory.redirect(upgradeOverview.nextStepUrl);
			}
		};
		
		function getNextStepUrl(isAboveUpgradeThreshold) {
			var nextStepUrl;

			if(isAboveUpgradeThreshold) {
				nextStepUrl = upgradeOverview.upgradeProperties.directUpgradeNextStepUrl;
			} else {
				nextStepUrl = urlFactory.serializeParamsAndCreateUrl('/account/additional-investment/start', {
					defaultAmount: 'minToUpgrade'
				});
			}

			return nextStepUrl;
		}

		upgradeOverview.$onInit = function() {
			angular.extend(upgradeOverview, globalConfig);

			var upgradeProperties = {
				CORE: {
					upgradeImagePath: STATIC_BASE_PATH + '/images/service-level/core-upgrade-icon-large-120818.png',
					directUpgradeNextStepUrl: '/account/upgrade/select-core-plan',
					upgradePerks: [
						{
							boldText: 'Customized plans',
							plainText: ' based on your investment objective'
						},
						{
							boldText: 'Diversification',
							plainText: ' across dozens more real estate projects'
						},
						{
							boldText: 'The Fundrise iPO',
							plainText: ' - get potential access to invest'
						}
					]
				},
				ADVANCED: {
					upgradeImagePath: STATIC_BASE_PATH + '/images/service-level/core-upgrade-icon-large-120818.png',
					directUpgradeNextStepUrl: '/account/upgrade/advanced/success'
				},
				PREMIUM: {
					upgradeImagePath: STATIC_BASE_PATH + '/images/service-level/premium-upgrade-icon-large.png',
					directUpgradeNextStepUrl: '/account/upgrade/accreditation-information',
					upgradePerks: [
						{
							boldText: '365 days of advisory fees waived',
							plainText: ' for every friend you refer'
						},
						{
							boldText: 'More to come',
							plainText: ' as we add new benefits to the Premium level'
						}
					]
				}
			};

			ServiceLevelFactory.getNextServiceLevel()
				.then(function(nextServiceLevel) {
					upgradeOverview.nextServiceLevel = nextServiceLevel;

					upgradeOverview.upgradeProperties = upgradeProperties[nextServiceLevel.name];

					upgradeOverview.cta = nextServiceLevel.isAboveUpgradeThreshold ? 'Upgrade now' : 'Invest and upgrade';
					upgradeOverview.nextStepUrl = getNextStepUrl(nextServiceLevel.isAboveUpgradeThreshold);
				});
		};
	}
})(window.angular);